import {
  getAllPnrssCountFromDB,
  getAllUsersCountFromDB,
} from "../../service/dashboard/dashBoardServicel";

const getAllUsersCount: () => Promise<number> = async () => {
  const usersCount = await getAllUsersCountFromDB();
  return usersCount;
};
const getAllpnrsCount: () => Promise<number> = async () => {
  const usersCount = await getAllPnrssCountFromDB();
  return usersCount;
};

export { getAllUsersCount, getAllpnrsCount };
